<template>
    <div class="container is-fluid">
        <div class="card">
            <div class="card-header-title" v-if="rounds.length > 0">Application Overview - {{ current_round[0].name }}</div>
        
            <div class="card-content">
                <table class="table is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th><span @click="changeGoverningBody('')" style="cursor:pointer">Governing Body</span></th>
                            <th>Applications</th>
                            <th>Endorsed</th>
                            <th>Not Endorsed</th>
                            <th>Outstanding</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr  v-for="(row, index) in applicationSummary" :key="index"  >
                            <td ><span @click="changeGoverningBody(index)" style="cursor:pointer">{{ row.name}}</span> <span v-if="row.email">( <a :href="'mailto:' + row.email ">{{ row.email }}</a> )</span></td>
                            <td>{{ row.total}}</td>
                            <td>{{ row.endorsed}}</td>
                            <td>{{ row.notendorsed}}</td>
                             <td v-bind:class=" {'is-success': row.outstanding === 0, 'is-warning': row.outstanding > 0 && (row.endorsed > 0 || row.notendorsed > 0), 'is-danger': row.outstanding > 0 && row.endorsed ===0 && row.notendorsed ===0 } ">{{ row.outstanding}}</td>
                        </tr>
                        
                    </tbody>
                   
                    </table>
            </div>
        </div>
        <br />
    </div>

</template>

<script>
import ApplicationService from '@/services/ApplicationService.js';
import UtilityService from '@/services/UtilityService.js';

export default {
  components: {
   	
  },
  data() {
    return {
       applicationSummary: [],
       accessToken: '',
       rounds: [],
       round_id:process.env.VUE_APP_CURRENT_ROUND_ID,
    }
  },
  computed: {
      current_round: function () {
        return this.rounds.filter(round => round.id == this.round_id)
      }
    },
  created() {
    this.getAccessToken()
    .then(() => { 
      this.getApplicationSummary();
      this.getRounds();
    });
    
   
  },
  methods: {
  	
    async getApplicationSummary() {
      
      // Use the eventService to call the getEventSingle() method
      ApplicationService.getApplicationSummary(this.accessToken)
      .then(
        (applicationSummary => {
          this.$set(this, "applicationSummary", applicationSummary);
        }).bind(this)
      );
    },
    changeGoverningBody(governingBodyId)
    {
      this.$emit('changeGoverningBody', governingBodyId)
      //alert(governingBodyId)
    },
    getRounds()
    {
      UtilityService.getSimpleApiData(this.accessToken, "rounds").then(
        response => this.rounds = response 
			);
    }

  },
  
}
</script>